import { render } from "./CallQueuesTable.vue?vue&type=template&id=411d0d6c"
import script from "./CallQueuesTable.vue?vue&type=script&lang=js"
export * from "./CallQueuesTable.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__